/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { uniqueId } from 'lodash';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { TEXT_VARIANTS, Text } from 'components/ui/Typography';
import { ItemTypes } from 'constants/reactDnDItemTypes';
import { ASSISTIVE_TEXT_STATES } from './AssistiveText';
import { CustomDragLayer } from './CustomDragLayer';
import MatchingChoicePreview from './MatchingChoicePreview';

const MatchingChoiceCard = ({
  questionId,
  removeMatch,
  match,
  setPairs,
  active,
  setAssistiveStatus,
  ariaLabel,
}) => {
  const [{ isDragging }, drag, preview] = useDrag({
    type: ItemTypes.MATCHING,
    item: { match, questionId },
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  useEffect(() => {
    // Uses a transparent empty Image to hide the browser-drawn drag preview completely
    preview(getEmptyImage());
  }, [preview]);

  const onClickChoice = () => {
    if (active === undefined) {
      setAssistiveStatus({
        state: ASSISTIVE_TEXT_STATES.ITEM_INACTIVE,
      });
      return;
    }

    const updatedValue = {};
    updatedValue[active] = match;
    setPairs(pairs => ({
      ...pairs,
      ...updatedValue,
    }));
    setAssistiveStatus({
      state: ASSISTIVE_TEXT_STATES.MATCH_SELECTED,
      match: match.match,
      activeItem: active,
    });
    removeMatch(match);
  };

  return (
    <div
      key={`${match.id}`}
      ref={drag}
      style={{ opacity: isDragging ? 0 : 1 }}
      onClick={onClickChoice}
      tabIndex="0"
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onClickChoice();
        }
      }}
      aria-label={ariaLabel}
    >
      <MatchingChoicePreview match={match} />
    </div>
  );
};

const MatchingChoice = props => {
  const {
    questionId,
    matches,
    removeMatch,
    setPairs,
    active,
    setAssistiveStatus,
    isActiveAriaLabel,
  } = props;

  const ariaLabel = (match, index) =>
    `Match option ${index + 1} of ${matches.length}. ${match}. ` +
    isActiveAriaLabel;
  return (
    <div className="MatchingMatchBank df fd-c">
      {!matches.length && (
        <div className="d-f jc-c pt-16 pb-16">
          <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="fs-i">
            {t('questions.choices.matching.empty_choices')}
          </Text>
        </div>
      )}
      {matches.map((match, index) => (
        <MatchingChoiceCard
          key={uniqueId('choice_')}
          questionId={questionId}
          removeMatch={removeMatch}
          match={match}
          setPairs={setPairs}
          active={active}
          setAssistiveStatus={setAssistiveStatus}
          ariaLabel={ariaLabel(match.match, index)}
        />
      ))}
      <CustomDragLayer />
    </div>
  );
};

export default MatchingChoice;
